import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type Item = {
  id: string;
  amount?: number;
};

export type GiftCardItemStore = {
  localGiftCardItem: Item | null;
  setLocalGiftCardItem: (item: Item) => void;
  removeLocalGiftCardItem: () => void;
};

export const useGiftCardItem = create<GiftCardItemStore>()(
  persist(
    set => ({
      localGiftCardItem: null,
      setLocalGiftCardItem: localGiftCardItem =>
        set(() => ({
          localGiftCardItem,
        })),
      removeLocalGiftCardItem: () => set({ localGiftCardItem: null }),
    }),
    {
      name: "local-gift-card-item-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
